/* eslint-disable */
// 労務安全用メッセージ
export const roan = {
  I: {
    DUMMY: 'DUMMY',
  },
  W: {
    DUMMY: 'DUMMY',
  },
  E: {
    DUMMY: 'DUMMY',
  },
};



// WEBPACK FOOTER //
// ./src/utilities/messages/roan.js